import DatePicker from '~/common/components/DatePicker';

type FbDatePickerProps = {
  name?: string;
  label?: string;
  placeholder?: string;
  getValues?: (...args: any[]) => any;
  disabled?: boolean;
  readOnly?: boolean;
  onChangeHandler?: (...args: any[]) => any;
  onBlur?: (...args: any[]) => any;
  isInvalid?: boolean;
  tabIndex?: number;
  dataTestId?: string;
  isRequired?: boolean;
};

export const FbDatePicker = ({
  name,
  label,
  placeholder,
  disabled,
  readOnly,
  getValues,
  onChangeHandler,
  onBlur,
  isInvalid,
  tabIndex,
  dataTestId,
  isRequired,
}: FbDatePickerProps) => (
  <DatePicker
    name={name}
    label={label}
    value={getValues(name)}
    data-testid={dataTestId}
    placeholder={placeholder}
    tabIndex={tabIndex}
    isRequired={isRequired}
    isDisabled={disabled}
    isReadOnly={readOnly}
    error={isInvalid}
    onChange={onChangeHandler}
    onBlur={onBlur}
  />
);
